import { Typography as TypographyMui } from '@common/components'
import { styled } from '@common/utils/styles'

export const Typography = styled(TypographyMui)(() => ({
  fontFamily: "'Inter','Roboto', 'Poppins', sans-serif",
}))
